import Dispatcher from '../dispatcher';
import CART_CONSTANTS from '../constants/cart';
import resolvePromise from '../helper/resolved_promise';
import API from '../../API/api';
import { createLatLangObjectFromString } from '../helper/gmap';
import { init as initSidebarLightBoxView } from '../../_views/sidebar/light_box';
import { show as showProductDetails } from '../../_flux/actions/sidebar/light_box';
import { show as showVoucherCode } from '../../_flux/actions/voucher_code_light_box_actions';
import { setAction } from '../../_flux/actions/products_actions';
import { init as initCrossSellRemoveLightBox } from '../../_views/cross_sell_remove_light_box/cross_sell_remove_light_box_view';
import { updateAction as updateProduct } from '../../_flux/actions/products_actions';
import { hideAction as crossSellHide } from '../../_flux/actions/cross_sell_remove_light_box_actions';
import { ProductsStore } from '../stores/products_store';
import { showAction as lockUi, hideAction as unlockUi } from '../actions/ui_lock_actions';
import { getCsrfTokenQueryParam, isCsrfTokenExists } from '../../utilities/csrf_token_provider';
import { setCartProductFlagAction } from './last_used_configurator_actions';
import {
  addAction as addCrossSellProduct,
  removeAction,
  updateAction as updateCrossSellAction,
} from '../../_flux/actions/cross_sell_products_actions.js';
import { CrossSellProductStore } from '../stores/cross_sell_product_store.js';

class CartActions {
  static async loadCartAction(skipLoading = false) {
    if (!skipLoading) {
      Dispatcher.handleCartAction({ type: CART_CONSTANTS.LOAD_CART_ACTION });
    }

    return await API.GET({
      apiPath: `${CART_CONSTANTS.GET_CART_API_PATH}${isCsrfTokenExists() ? `?${getCsrfTokenQueryParam()}` : ''}`,
      dataType: 'json',
    })
      .done((payload) => {
        const {
          cart: { products },
        } = payload;
        const $cartCount = window.$cartCount;
        const isVehicleDetails = location.pathname.indexOf('/checkout/') !== -1;

        if (!!location.pathname.match(/\/tyre-shops\//)) {
          setAction(products);
        }

        if ($cartCount) {
          $cartCount.text(products.length).addClass('navigation-level-1-cart-count--visible');
        }

        Dispatcher.handleCartAction({ type: CART_CONSTANTS.CART_LOADED_ACTION, payload });

        const latLng = payload.location;
        if (latLng && typeof latLng.lat !== 'undefined' && typeof latLng.lng !== 'undefined') {
          let newLatLng = createLatLangObjectFromString(parseFloat(latLng.lat), parseFloat(latLng.lng));
          if (false !== newLatLng.lat() && false !== newLatLng.lng()) {
            Dispatcher.handleMapAction({ type: 'SET_LATLNG', payload: newLatLng });
          }
        }

        if (
          payload.cart &&
          payload.cart.products &&
          !TYROOLA.page.$container.hasClass('product') &&
          !TYROOLA.page.$container.hasClass('catalog')
        ) {
          // Set preselected value as true for cross_sell_product, because when cross_sell_product is in cart that means its always true
          payload.cart.products
            .filter((p) => p.cartProductType === 'cross_sell_product')
            .map((p) => ({ ...p, spinachId: p.spinach, price: p.priceRaw, preselected: true }))
            .forEach(addCrossSellProduct);
          TYROOLA.initialFluxStates.cartProducts = payload.cart.products
            .filter((p) => p.cartProductType !== 'cross_sell_product')
            .map((p) => ({ ...p, spinachId: p.spinach, price: p.priceRaw }));
          isVehicleDetails && setCartProductFlagAction(true);
        }

        const postcode = payload.postcode;
        if (postcode && postcode.length > 0) {
          Dispatcher.handleMapAction({ type: 'FETCH_LATLNG', payload: postcode });
        }

        if (!isVehicleDetails) {
          initSidebarLightBoxView(document.getElementById('sidebar-light-box'), {
            currencyIsoCode: TYROOLA.globals.currencyIsoCode,
          });
        }

        initCrossSellRemoveLightBox(document.getElementById('cross-sell-remove'), {
          onRemove: CartActions.removeProductFromCart.bind(this),
        });

        let productItems = [...payload.cart.products];
        productItems = productItems.map((p, i) => ({
          ...p,
          price: p.priceRaw,
          id: p.id || p.spinach || `key-${i}`,
          brand: p.brand || p.manufacturer,
          size: p.size || p.dimensions,
          model: p.model || p.details,
          isFittingAvailable: !!payload?.checkout?.addressShipping?.shippingPostCode,
          fromTopCart: true,
        }));

        window.fromTopCart = true;
        TYROOLA.initialFluxStates.topCartProducts = productItems;

        const cartIcon = document.querySelector('a[href$="/cart/"]');
        const cartDetailsLightbox = document.querySelectorAll('.cart-details-lightbox');
        const sidebarVoucherCodeLightbox = document.querySelectorAll('.sidebar-voucher-code');

        if (cartIcon && this) {
          cartIcon.addEventListener('click', this.onClickCartDetail.bind(this));
        }

        cartDetailsLightbox.forEach((cartDetail) => {
          if (cartDetail && this) {
            cartDetail.addEventListener('click', this.onClickCartDetail.bind(this));
          }
        });

        sidebarVoucherCodeLightbox.forEach((voucherCode) => {
          if (voucherCode && this) {
            voucherCode.addEventListener('click', this.onClickVoucherCodeLink.bind(this));
          }
        });
      })
      .catch(() => {
        Dispatcher.handleCartAction({ type: CART_CONSTANTS.CART_LOADED_ERROR_ACTION });
      });
  }

  static onClickVoucherCodeLink(e) {
    e.stopPropagation();
    e.preventDefault();
    let voucherPDPData = null;

    if (TYROOLA.page.$container.hasClass('product')) {
      const { voucherData } = TYROOLA.initialFluxStates;
      const productsState = ProductsStore.getState();
      const crossSellProducts = CrossSellProductStore.getState();
      const hasCrossSellProducts = crossSellProducts && crossSellProducts.length;
      voucherPDPData = {
        qty: productsState[0].qty,
        id: productsState[0].id,
        crossSellProducts: hasCrossSellProducts
          ? crossSellProducts
              .filter((csp) => csp.preselected)
              .map((csp) => ({ spinachId: csp.spinachId, cartQty: csp.syncQty ? productsState[0].qty * 1 : 1 }))
          : undefined,
        idVouchers: voucherData && voucherData.allDiscounts ? voucherData.allDiscounts.map((d) => d.idVoucher) : [],
        newVoucher: {
          voucherValue: '',
        },
      };
    }

    showVoucherCode(voucherPDPData);
  }

  static onClickCartDetail(e) {
    e.stopPropagation();
    e.preventDefault();

    showProductDetails();
  }

  static updateCartAction(payload) {
    Dispatcher.handleCartAction({ type: CART_CONSTANTS.CART_LOADED_ACTION, payload });
    return resolvePromise();
  }

  static async removeProductFromCart(data) {
    try {
      lockUi();
      if (!TYROOLA.page.$container.hasClass('product') || data.removeFromCart) {
        await API.DELETE({
          apiPath: `/cart/remove/?${getCsrfTokenQueryParam()}`,
          data: JSON.stringify({ id: data.spinachId }),
          dataType: 'json',
          contentType: 'application/json; charset=utf-8',
        });

        unlockUi();
        location.reload();
      } else {
        if (!data.showAddToCartInputElem) {
          const removeIndex = TYROOLA.initialFluxStates.crossSellProducts.findIndex(
            (x) => x.spinachId === data.spinachId,
          );
          TYROOLA.initialFluxStates.crossSellProducts.splice(removeIndex, 1);
          removeAction(data.spinachId);
        }
        updateCrossSellAction({ spinachId: data.spinachId, preselected: false });
        const id = ProductsStore.getState()[0].id;
        updateProduct({ id });
        crossSellHide();
        unlockUi();
      }
    } catch (err) {
      console.log(err);
    }
  }
}

export default CartActions;
